import { render, staticRenderFns } from "./metaPageTotal.vue?vue&type=template&id=61c94f36&scoped=true&lang=pug"
import script from "./metaPageTotal.vue?vue&type=script&lang=js"
export * from "./metaPageTotal.vue?vue&type=script&lang=js"
import style0 from "./metaPageTotal.vue?vue&type=style&index=0&id=61c94f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c94f36",
  null
  
)

export default component.exports